/* global Stimulus */
console.log("template0/policies.js Loaded");

//* Bootstrap
import "bootstrap/js/dist/collapse"; //* For the Accordions

//* Stimulus
import copyable_input from "../../view_components/copyable_input/index.js";
Stimulus.register("copyable-input", copyable_input);
